import type { Scheme } from '../types/configs';
import MediaPicker from './MediaPicker';

type CameraProps = {
  show: boolean;
  scheme: Scheme;
  onCameraUsed: (...args: any[]) => void;
  onCameraError: (...args: any[]) => void;
};

export default function CameraButton(props: CameraProps) {
  const {
    show,
    onCameraError,
    onCameraUsed,
    scheme: {
      header: { messageBarColor },
    },
  } = props;
  return (
    <>
      {show && (
        <MediaPicker
          mediaType='image'
          useCamera
          onAttached={onCameraUsed}
          onError={onCameraError}>
          <button
            type='button'
            style={{ backgroundColor: messageBarColor }}
            className='camera-button'>
            <i className='fas fa-camera' />
          </button>
        </MediaPicker>
      )}
    </>
  );
}
